import React, { useContext, useState } from "react";
import { Navbar, Button, Badge } from "react-bootstrap";
import { NavLink } from "react-router";
import Icon from './Icon';
import {
    faWifi as cloudOfflineOutline,
    faCloud as cloudOutline,
    faSync as sync,
    faUser as userIcon,
    faExclamationTriangle as warningIcon,
} from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router';
import Tabs from "./tabs";
import WheelPropsModal from "./wheelPropsModal";
import { WebSocketContext } from "../websocket/websocket";
import { InstructionModal } from "./instructionModal";
import { UserContext } from "../components/auth/auth";
import version from "../ver.json";
import { useProfileModal } from "../contexts/profileModalContext";
import useWheelId from "../hooks/useWheelId";

export default function Menu() {
    const navigate = useNavigate();
    const wheelId = useWheelId();
    const websocket = useContext(WebSocketContext);
    const user = useContext(UserContext);
    const { openProfile } = useProfileModal();
    const [propsDialog, setPropsDialog] = useState(false);
    const [showInstruction, setShowInstruction] = useState(false);
    const toggleProps = () => setPropsDialog(false);

    if (!websocket)
        return

    // Проверяем наличие предупреждений о лимите
    const hasLimitWarning = websocket.limitWarnings && websocket.limitWarnings.size > 0;

    const handleLimitClick = () => {
        navigate(`/${wheelId}/tariffs?reason=limit_exceeded`);
    };

    return (
        <div style={{ zIndex: 1040 }}>
            <Navbar bg="body" className="mb-3">
                <div className="d-flex align-items-center w-100">
                    {/* Левая часть: Лого, статус соединения, версия */}
                    <div className="d-flex align-items-center">
                        <Navbar.Brand as={NavLink} to="/" style={{ marginRight: '12px', textDecoration: 'none' }}>
                            <img src="/logo.png" width={40} height={40} alt="Артефакты" />
                        </Navbar.Brand>
                        <div className="d-flex flex-column">
                            {/* Офлайн (приоритет) */}
                            {!websocket.connected && (
                                <Badge bg="secondary" style={{ cursor: "pointer" }} onClick={websocket.reconnect}>
                                    <Icon icon={cloudOfflineOutline} /> Оффлайн
                                </Badge>
                            )}
                            {/* Предупреждение о лимите */}
                            {websocket.connected && hasLimitWarning && (
                                <Badge bg="warning" style={{ cursor: "pointer", color: "#212529" }} onClick={handleLimitClick}>
                                    <Icon icon={warningIcon} /> Есть не сохраненные объекты
                                </Badge>
                            )}
                            {/* Синхронизация */}
                            {websocket.connected && (!websocket.syncDone || websocket.syncInProgress) && !hasLimitWarning && (
                                <Badge bg="info">
                                    <Icon icon={sync} spin /> Синхронизация
                                </Badge>
                            )}
                            {/* Онлайн */}
                            {websocket.connected && websocket.syncDone && !websocket.syncInProgress && !hasLimitWarning && (
                                <Badge bg="success">
                                    <Icon icon={cloudOutline} /> Онлайн
                                </Badge>
                            )}
                        </div>
                        <Navbar.Text className="ms-2 text-muted"><small>v{version.ver}</small></Navbar.Text>
                    </div>

                    {/* Центральная часть: Навигация */}
                    <div className="flex-grow-1 d-flex justify-content-center">
                        <Tabs />
                    </div>

                    {/* Правая часть: Профиль */}
                    <div className="d-flex align-items-center">
                        <Navbar.Text>
                            <Button size="sm" variant="outline-secondary" style={{ cursor: "pointer", width: 32, height: 32, padding: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={() => openProfile()}>
                                <Icon icon={userIcon} style={{ fontSize: 16 }} />
                            </Button>
                        </Navbar.Text>
                    </div>
                </div>
            </Navbar>
            <WheelPropsModal toggle={toggleProps} popup={propsDialog} key={'wheel'} />
            <InstructionModal show={showInstruction} onHide={() => setShowInstruction(false)} />
        </div>
    );
}